import { MailOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Grid, Tooltip } from 'antd';
import React from 'react';
import { SuccessButton } from './SuccessButton';

const { useBreakpoint } = Grid;

interface EmailButtonProps {
  onClick: (e: React.MouseEvent) => void;
  tooltip?: string;
  size?: 'small' | 'middle' | 'large';
  iconOnly?: boolean;
  showText?: boolean;
  block?: boolean;
}

export const EmailButton: React.FC<EmailButtonProps> = ({
  onClick,
  tooltip = 'Send email',
  size,
  iconOnly = false,
  showText,
  block = false,
}) => {
  const screens = useBreakpoint();
  const shouldShowText = showText ?? (!iconOnly && screens.md);

  return (
    <Tooltip title={tooltip}>
      <SuccessButton size={size} icon={<MailOutlined />} onClick={onClick} block={block}>
        {shouldShowText ? L('Send email') : null}
      </SuccessButton>
    </Tooltip>
  );
};
